import request from './request'
// import alertUtils from './alertUtils'
/**
 * 表单工具
 */
export default class formUtils {
  /**
   * @desc 获取远端数据
   * @param key
   * @param url
   */
  static getRemoteValue(key, url) {
    if (this.isNotNull(url)) {
      request({
        url: url,
        method: 'get',
      }).then(response => {
        if (this.isNotNull(key)) {
          return response[key]
        } else {
          return response
        }
      })
    }
  }

  /**
   * @desc 获取url上参数
   * @param variable
   * @returns {*}
   */
  static getQueryVariable(variable) {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      if (pair[0] === variable) {
        return pair[1]
      }
    }
    return null
  }

  /**
   * @desc 根据code获取不同的值
   * @param str
   */
  static getValueWithCode(str) {
    if (this.isNotNull(str)) {
      if (str === 'dateStr') {
        return this.dateStr()
      } else if (str === 'uuidStr') {
        return this.uuidStr()
      }
    }
    return ''
  }

  /**
   * 判断数组是否包含某字符
   * @param array
   * @param str
   * @returns {boolean}
   */
  static arrayContainsStr(array, str) {
    if (array && array.length > 0) {
      const length = array.length
      for (let i = 0; i < length; i++) {
        if (array[i] && str && array[i] === str) {
          return true
        }
      }
    }
    return false
  }

  /**
   * @desc 判断字符串是否为空
   * @param str
   * @returns {boolean}
   */
  static isNull(str) {
    return str === null || str === '' || str.length === 0
  }

  /**
   * @desc 判断字符串不为空
   * @param str
   * @returns {boolean}
   */
  static isNotNull(str) {
    return str !== null && str.length > 0 && str !== ''
  }

  /**
   * 对象是否是null
   * @param obj
   * @returns {boolean}
   */
  static objectIsNull(obj) {
    if (obj) {
      if (JSON.stringify(obj) === '{}') {
        return true
      }
    } else {
      return true
    }
    return false
  }

  /**
   *  List 是否是null
   * @param obj
   * @returns {boolean}
   */
  static listIsNull(obj) {
    if (obj) {
      if (obj.length <= 0 || JSON.stringify(obj) === '[]') {
        return false
      }
    } else {
      return false
    }
    return true
  }

  /**
   * @desc 生成时间戳
   * @returns {string}
   */
  static dateStr() {
    return new Date().getTime() + ''
  }

  /**
   * @desc 获取UUID
   * @returns {string}
   */
  static uuidStr() {
    let d = new Date().getTime()
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
      }
    )
    return uuid
  }

  /**
   * @desc  判断是否为身份证号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  static isIdCard(str) {
    return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(
      str
    )
  }

  /**
   * @desc   判断是否为手机号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  static isPhoneNum(str) {
    return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str)
  }

  /**
   * @desc 根据组件List 集合，拆分成单个个体  name 、model 、key
   * @param dataList
   * @returns {Array}
   */
  static getComponentsListInfo(dataList) {
    if (dataList && dataList.length > 0) {
      const componentsList = []
      this.componentsListInfo(componentsList, dataList)
      return componentsList
    }
    return []
  }

  static componentsListInfo(componentsList, dataList) {
    for (let i = 0; i < dataList.length; i++) {
      if (dataList[i].type === 'grid') {
        // 栅格
        dataList[i].columns.forEach(item => {
          this.componentsListInfo(componentsList, item.list)
        })
      } else if (dataList[i].type === 'sonform') {
        // 子表单
        componentsList.push(this.componentsInfo(dataList[i]))
        this.componentsListInfo(componentsList, dataList[i].list)
      } else {
        componentsList.push(this.componentsInfo(dataList[i]))
      }
    }
  }

  static componentsInfo(data) {
    return {
      type: data.type,
      name: data.name,
      key: data.key,
      model: data.model,
      icon: data.icon,
      isSon: data.options.isSon,
    }
  }

  /**
   * 去除某些项目 --- 根据     delTypes  类型组合
   * @param componentsList
   */
  static componentsInfoDelOthers(componentsList, delTypes, delSon) {
    const list = []
    for (let i = 0; i < componentsList.length; i++) {
      if (
        delTypes.indexOf(componentsList[i].type) < 0 &&
        delSon === componentsList[i].isSon
      ) {
        list.push(componentsList[i])
      }
    }
    return list
  }

  static modelToName(list) {
    const map = {}
    for (let i = 0; i < list.length; i++) {
      map[list[i].model] = list[i].name
    }
    return map
  }

  static fieldToName(list, fields) {
    const map = {}
    if (list && fields) {
      const fieldList = this.getComponentsListInfo(list)
      if (fieldList && fieldList.length > 0) {
        for (let i = 0; i < fieldList.length; i++) {
          for (let j = 0; j < fields.length; j++) {
            if (fieldList[i].model === fields[j]) {
              map[fields[j]] = fieldList[i].name
            }
          }
        }
      }
    }
    return map
  }
}
